export default {
	title: "Lyckohjul",
	Lucky: "Lycka",
	wheels: "Hjul",
	winningrecord: "Vinsthistorik",
	ActivityRules: "Aktivitetsregler",
	ActivityRulesContent: "För mer information om lotteriet, vänligen kontakta vår kundtjänst.",
	award: {
		title: "Grattis till vinsten!",
		btn: "Ta emot pris"
	},
	noticeItem: "{0} har fått {1}",
	lotteryDraws: "{0} lotteridragningar",
	noAvailableTimes: "Otillräckligt antal försök. Vänligen kontakta kundtjänst.",
	noOpen: "Ännu inte öppet",
	noWinning: "Fortsätt försöka",
	ViewALlPrizes: "Visa alla priser",
	myPrizes: "Mina priser",
	share: "Dela med en vän"
};
